(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boho-v2-journal-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.bohoV2JournalReveal) return;
    window.bohoV2JournalReveal = true;
    var root = document.documentElement;
    function still() {
      if (typeof window.bohoV2MotionStill === 'function') return window.bohoV2MotionStill();
      if (root.classList.contains('bv2-still')) return true;
      try { if (window.localStorage.getItem('bv2-motion') === 'paused') return true; } catch (e) {}
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function run() {
      if (still() || !('IntersectionObserver' in window)) return;
      var fold = window.innerHeight * 0.92;
      var els = Array.prototype.slice.call(document.querySelectorAll('[data-bv2-jr]')).filter(function (el) {
        return el.getBoundingClientRect().top > fold;
      });
      if (!els.length) return;
      var io = new IntersectionObserver(function (entries) {
        var i = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--bv2-r-delay', Math.min(i * 90, 270) + 'ms');
          i += 1;
          entry.target.setAttribute('data-bv2-in', '');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { el.setAttribute('data-bv2-r', ''); io.observe(el); });
      root.classList.add('bv2-reveal-on');
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
  } catch(e) { console.error(e); }
})();

})();
